import DateRestriction from "../classes/DateRestriction";
import Promotion from "./Promotion";

class TicketType {
    admin_fee:number = 0;
    admin_fee_absorbed:number = 0;
    applicable_for_date:boolean = false;
    bundle_ticket_parent_sold_out:boolean = false;
    bundle_ticket_type: any[] = [];
    bundle_ticket_title: string[] = [];
    created_date:string = "";
    custom_ticket_labels: any[] = [];
    customer_vat_rate:string|null = null;
    date_restrictions: DateRestriction|any = null;
    deleted:boolean = false;
    desc: any = null;
    description:string = "";
    discount_codes_used: any[] = [];
    dmn_commission_amount:number = 0;
    dmn_commission_percentage:number = 0;
    end_time:string = "";
    fixed_ticket_quantities_per_purchase:any[] = [];
    filtered: boolean = true;
    id:string = "";
    is_sold_out:boolean = false;
    labels: string[];
    min_tickets_per_purchase: number = 1;
    max_tickets_per_purchase: number = 99;
    max_ticket_sales:number = 0;
    name:string = "";
    price:number = 0;
    price_excluding_vat:string = "";
    promotion: Promotion|undefined = undefined;
    remaining: any = 0;
    sell_from:any = null;
    sell_from_invalid: boolean = false;
    sell_until:string = "";
    show_start_time:boolean = false;
    start_time:string = "";
    status:string = "";
    tags: any[] = [];
    ticket_type:string = "";
    ticket_type_group:any = null;
    total_ticket_admin_fee:number = 0;
    total_ticket_admin_fee_absorbed:number = 0;
    total_ticket_attendees:number = 0;
    total_ticket_attendees_and_reservations:number = 0;
    total_ticket_checkout_reservations:number = 0;
    total_ticket_discounted:number = 0;
    total_ticket_discounted_value:number = 0;
    total_ticket_dmn_commission:number = 0;
    total_ticket_dmn_commission_vat_amount:number = 0;
    total_ticket_dmn_revenue:number = 0;
    total_ticket_guests:number = 0;
    total_ticket_profit_value:number = 0;
    total_ticket_quota:number = 100;
    total_ticket_rep_commission:number = 0;
    total_ticket_rep_sales:number = 0;
    total_ticket_reservations:number = 0;
    total_ticket_sales:number = 0;
    total_ticket_sales_value:number = 0;
    total_ticket_tonic_reservations:number = 0;

    constructor(ticketData?: any) {
        // get each key
        if(ticketData) {
            for(let key in ticketData) {
                if (this.hasOwnProperty(key)) {
                    (<any>this)[key] = ticketData[key];
                }
            }
        }

        this.labels = this.getTicketTypeLabels();
    }

    /**
     * @desc get the labels for each ticket
     * @param {string} - ticketId
     * @return {array}
     */
    getTicketTypeLabels() : string[] {
        let ticketLabels = [];

        // set min/max labels
        let fixedQuantities = this.fixed_ticket_quantities_per_purchase || [];

        if(!fixedQuantities.length) {

            // check for min restriction
            if(this.min_tickets_per_purchase && this.min_tickets_per_purchase > 1) {
                ticketLabels.push( `Minimum ${this.min_tickets_per_purchase} tickets` );
            }

            // check for max restriction
            if(this.max_tickets_per_purchase && this.max_tickets_per_purchase !== 99) {
                let maxLabel = `Maximum ${this.max_tickets_per_purchase} ticket`;

                if(this.max_tickets_per_purchase > 1) {
                    maxLabel += 's';
                }

                ticketLabels.push(maxLabel);
            }
        }

        // check for bundle ticket rule
        if(this.bundle_ticket_type.length) {
            ticketLabels.push(this.getBundleTicketsLabel());
        }

        return ticketLabels;
    };

    getBundleTicketsLabel(): string
    {
        let bundleLabel = 'Must be bought with ';
        this.bundle_ticket_title = this.bundle_ticket_title.filter((item) => {
            return typeof item !== 'undefined';
        });
        let publicTickets = this.bundle_ticket_type.slice(-1 * this.bundle_ticket_title.length);
        if (publicTickets.length > 3) {
            publicTickets.slice(0, 3).forEach((bundle_ticket, index) => {
                bundleLabel += `${this.bundle_ticket_title[index]}, `;
            });
            bundleLabel = bundleLabel.slice(0, -2);
            bundleLabel += ` or ${publicTickets.length - 3} others`;
        } else if (publicTickets.length > 1) {
            publicTickets.slice(0, -1).forEach((bundle_ticket, index) => {
                bundleLabel += `${this.bundle_ticket_title[index]}, `;
            });
            bundleLabel = bundleLabel.slice(0, -2);
            bundleLabel += ` or ${this.bundle_ticket_title.pop()}`;
        } else {
            bundleLabel += `${this.bundle_ticket_title[0]}`;
        }

        return bundleLabel;
    }
}

export default TicketType;
